import React from 'react'

export default function Disk() {
    return (
        <div>
            <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M50 29.1666L39.5833 4.16663H10.4167L0 29.1666V45.8333H50V29.1666ZM13.1958 8.33329H36.8062L44.6187 27.0833H5.38125L13.1958 8.33329ZM45.8333 41.6666H4.16667V31.25H45.8333V41.6666ZM40.6312 37.5H9.36875C7.9875 37.5 7.9875 35.4166 9.36875 35.4166H40.6312C42.0125 35.4166 42.0125 37.5 40.6312 37.5Z" fill="#BB0600" />
            </svg>
        </div>
    )
}
